import axiosModule from "@/util/axios-module";
import { ResponseWrapper, ErrorWrapper } from "./util";

export class AuthService {
  constructor() {}
  static async Login({ email, password }) {
    try {
      const response = await axiosModule.post("/auth", {
        username: email,
        password,
        grant_type: "password",
      });
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
  static async FetchUser() {
    try {
      const response = await axiosModule.get("/users/me");
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
  static async isMaintenance(key) {
    try {
      const response = await axiosModule.get(`/settings?key=${key}`);
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
  static async RegisterUser(user) {
    try {
      const response = await axiosModule.post("/auth/register", user);
      return response.status === 200 ? response.data : response;
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async ForgotPassword(email) {
    try {
      const response = await axiosModule.post("/auth/forgotPassword", email);
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
  static async UpdateUser(credentials) {
    try {
      const response = await axiosModule.post(
        "/users/updateProfile",
        credentials
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
  static async ChangePassword(credentials) {
    try {
      const response = await axiosModule.post(
        "/auth/changePassword",
        credentials
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async ResetPassword(credentials) {
    try {
      const response = await axiosModule.post(
        "/auth/resetPassword",
        credentials
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
}
